/**
 * Smoothscroll & fixed header auto-offset
 *
 * @package hum-wp
 */


jQuery(function($){

	// Smooth Scroll
	$("#totop").click(function () {

    //1 second of animation time
    //html works for FFX but not Chrome
    //body works for Chrome but not FFX
    //This strange selector seems to work universally

    $("html, body").animate({scrollTop: 0}, 600);
  });

});
